export default "__VITE_ASSET___zo1cSf7__"